<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbs" />
    <SalesPerProduct />
  </Layout>
</template>

<script>
import Layout from '@/views/Layout'
import SalesPerProduct from '@/components/Reports/Products/SalesPerProducts.vue'

export default {
  name: 'SalesProducts',
  components: {
    Layout,
    SalesPerProduct
  },
  computed: {
    breadcrumbs: () => [
      {
        text: 'Início',
        to: { name: 'HomeIndex' }
      },
      {
        text: 'Relatórios',
        to: { name: 'ReportsIndex' }
      },
      {
        text: 'Produtos',
        to: { name: 'SalesPerProduct' },
        active: true
      }
    ]
  }
}
</script>
